/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Impero Org API
 * The Impero Backend's API for organizations, i.e. orgname.impero.com.
 */
import { useMutation, useQuery, useSuspenseQuery } from "@tanstack/react-query";
import type {
    DataTag,
    DefinedInitialDataOptions,
    DefinedUseQueryResult,
    MutationFunction,
    QueryClient,
    QueryFunction,
    QueryKey,
    UndefinedInitialDataOptions,
    UseMutationOptions,
    UseMutationResult,
    UseQueryOptions,
    UseQueryResult,
    UseSuspenseQueryOptions,
    UseSuspenseQueryResult,
} from "@tanstack/react-query";

import axios from "axios";
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";

import type {
    ControlEntityConflict,
    ControlProgramId,
    ControlProgramOverview,
    ControlProgramOverviewResource,
    ControlProgramOverviewResourceDto,
    ControlProgramOverviewResourceListDto,
    ControlProgramTagCategoryId,
    ControlProgramTagCategoryWithTagsView,
    ControlProgramTagId,
    ControlProgramTagView,
    ControlProgramTagViewListDto,
    DataSheetAssignmentsListDto,
    GetControlProgramsParams,
    NewControlProgram,
    NewControlProgramTag,
    NewControlProgramTagCategoryWithTags,
    PostControlProgramsCopyParams,
    UpdatableControlProgram,
    UpdatableControlPrograms,
} from "../model";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

const withQueryKey = <T extends object, K>(
    query: T,
    queryKey: K
): T & { queryKey: K } => {
    const result = { queryKey } as T & { queryKey: K };
    for (const key of Object.keys(query)) {
        // The explicit queryKey always wins, matching the previous
        // `{ ...query, queryKey }` spread where it was set last.
        if (key === "queryKey") continue;
        Object.defineProperty(result, key, {
            enumerable: true,
            configurable: true,
            get: () => (query as Record<string, unknown>)[key],
        });
    }
    return result;
};

export const getControlProgramsControlProgramId = (
    controlProgramId: ControlProgramId,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<ControlProgramOverviewResourceDto>> => {
    return axios.get(`/api/control-programs/${controlProgramId}`, options);
};

export const getGetControlProgramsControlProgramIdQueryKey = (
    controlProgramId: ControlProgramId
) => {
    return [`/api/control-programs/${controlProgramId}`] as const;
};

export const getGetControlProgramsControlProgramIdQueryOptions = <
    TData = Awaited<ReturnType<typeof getControlProgramsControlProgramId>>,
    TError = AxiosError<unknown>,
>(
    controlProgramId: ControlProgramId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getControlProgramsControlProgramId>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getGetControlProgramsControlProgramIdQueryKey(controlProgramId);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getControlProgramsControlProgramId>>
    > = ({ signal }) =>
        getControlProgramsControlProgramId(controlProgramId, {
            signal,
            ...axiosOptions,
        });

    return {
        queryKey,
        queryFn,
        enabled: controlProgramId !== null && controlProgramId !== undefined,
        ...queryOptions,
    } as UseQueryOptions<
        Awaited<ReturnType<typeof getControlProgramsControlProgramId>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetControlProgramsControlProgramIdQueryResult = NonNullable<
    Awaited<ReturnType<typeof getControlProgramsControlProgramId>>
>;
export type GetControlProgramsControlProgramIdQueryError = AxiosError<unknown>;

export function useGetControlProgramsControlProgramId<
    TData = Awaited<ReturnType<typeof getControlProgramsControlProgramId>>,
    TError = AxiosError<unknown>,
>(
    controlProgramId: ControlProgramId,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getControlProgramsControlProgramId>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<
                        ReturnType<typeof getControlProgramsControlProgramId>
                    >,
                    TError,
                    Awaited<
                        ReturnType<typeof getControlProgramsControlProgramId>
                    >
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetControlProgramsControlProgramId<
    TData = Awaited<ReturnType<typeof getControlProgramsControlProgramId>>,
    TError = AxiosError<unknown>,
>(
    controlProgramId: ControlProgramId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getControlProgramsControlProgramId>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<
                        ReturnType<typeof getControlProgramsControlProgramId>
                    >,
                    TError,
                    Awaited<
                        ReturnType<typeof getControlProgramsControlProgramId>
                    >
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetControlProgramsControlProgramId<
    TData = Awaited<ReturnType<typeof getControlProgramsControlProgramId>>,
    TError = AxiosError<unknown>,
>(
    controlProgramId: ControlProgramId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getControlProgramsControlProgramId>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetControlProgramsControlProgramId<
    TData = Awaited<ReturnType<typeof getControlProgramsControlProgramId>>,
    TError = AxiosError<unknown>,
>(
    controlProgramId: ControlProgramId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getControlProgramsControlProgramId>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetControlProgramsControlProgramIdQueryOptions(
        controlProgramId,
        options
    );

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getGetControlProgramsControlProgramIdSuspenseQueryOptions = <
    TData = Awaited<ReturnType<typeof getControlProgramsControlProgramId>>,
    TError = AxiosError<unknown>,
>(
    controlProgramId: ControlProgramId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getControlProgramsControlProgramId>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getGetControlProgramsControlProgramIdQueryKey(controlProgramId);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getControlProgramsControlProgramId>>
    > = ({ signal }) =>
        getControlProgramsControlProgramId(controlProgramId, {
            signal,
            ...axiosOptions,
        });

    return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getControlProgramsControlProgramId>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetControlProgramsControlProgramIdSuspenseQueryResult = NonNullable<
    Awaited<ReturnType<typeof getControlProgramsControlProgramId>>
>;
export type GetControlProgramsControlProgramIdSuspenseQueryError =
    AxiosError<unknown>;

export function useGetControlProgramsControlProgramIdSuspense<
    TData = Awaited<ReturnType<typeof getControlProgramsControlProgramId>>,
    TError = AxiosError<unknown>,
>(
    controlProgramId: ControlProgramId,
    options: {
        query: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getControlProgramsControlProgramId>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetControlProgramsControlProgramIdSuspense<
    TData = Awaited<ReturnType<typeof getControlProgramsControlProgramId>>,
    TError = AxiosError<unknown>,
>(
    controlProgramId: ControlProgramId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getControlProgramsControlProgramId>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetControlProgramsControlProgramIdSuspense<
    TData = Awaited<ReturnType<typeof getControlProgramsControlProgramId>>,
    TError = AxiosError<unknown>,
>(
    controlProgramId: ControlProgramId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getControlProgramsControlProgramId>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetControlProgramsControlProgramIdSuspense<
    TData = Awaited<ReturnType<typeof getControlProgramsControlProgramId>>,
    TError = AxiosError<unknown>,
>(
    controlProgramId: ControlProgramId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getControlProgramsControlProgramId>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions =
        getGetControlProgramsControlProgramIdSuspenseQueryOptions(
            controlProgramId,
            options
        );

    const query = useSuspenseQuery(
        queryOptions,
        queryClient
    ) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const deleteControlProgramsControlProgramId = (
    controlProgramId: ControlProgramId,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<void>> => {
    return axios.delete(`/api/control-programs/${controlProgramId}`, options);
};

export const getDeleteControlProgramsControlProgramIdMutationOptions = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof deleteControlProgramsControlProgramId>>,
        TError,
        { controlProgramId: ControlProgramId },
        TContext
    >;
    axios?: AxiosRequestConfig;
}): UseMutationOptions<
    Awaited<ReturnType<typeof deleteControlProgramsControlProgramId>>,
    TError,
    { controlProgramId: ControlProgramId },
    TContext
> => {
    const mutationKey = ["deleteControlProgramsControlProgramId"];
    const { mutation: mutationOptions, axios: axiosOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof deleteControlProgramsControlProgramId>>,
        { controlProgramId: ControlProgramId }
    > = (props) => {
        const { controlProgramId } = props ?? {};

        return deleteControlProgramsControlProgramId(
            controlProgramId,
            axiosOptions
        );
    };

    return { mutationFn, ...mutationOptions };
};

export type DeleteControlProgramsControlProgramIdMutationResult = NonNullable<
    Awaited<ReturnType<typeof deleteControlProgramsControlProgramId>>
>;

export type DeleteControlProgramsControlProgramIdMutationError =
    AxiosError<unknown>;

export const useDeleteControlProgramsControlProgramId = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof deleteControlProgramsControlProgramId>>,
            TError,
            { controlProgramId: ControlProgramId },
            TContext
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<typeof deleteControlProgramsControlProgramId>>,
    TError,
    { controlProgramId: ControlProgramId },
    TContext
> => {
    return useMutation(
        getDeleteControlProgramsControlProgramIdMutationOptions(options),
        queryClient
    );
};
export const patchControlProgramsControlProgramId = (
    controlProgramId: ControlProgramId,
    updatableControlProgram: UpdatableControlProgram,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<ControlProgramOverviewResource>> => {
    return axios.patch(
        `/api/control-programs/${controlProgramId}`,
        updatableControlProgram,
        options
    );
};

export const getPatchControlProgramsControlProgramIdMutationOptions = <
    TError = AxiosError<ControlEntityConflict>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof patchControlProgramsControlProgramId>>,
        TError,
        { controlProgramId: ControlProgramId; data: UpdatableControlProgram },
        TContext
    >;
    axios?: AxiosRequestConfig;
}): UseMutationOptions<
    Awaited<ReturnType<typeof patchControlProgramsControlProgramId>>,
    TError,
    { controlProgramId: ControlProgramId; data: UpdatableControlProgram },
    TContext
> => {
    const mutationKey = ["patchControlProgramsControlProgramId"];
    const { mutation: mutationOptions, axios: axiosOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof patchControlProgramsControlProgramId>>,
        { controlProgramId: ControlProgramId; data: UpdatableControlProgram }
    > = (props) => {
        const { controlProgramId, data } = props ?? {};

        return patchControlProgramsControlProgramId(
            controlProgramId,
            data,
            axiosOptions
        );
    };

    return { mutationFn, ...mutationOptions };
};

export type PatchControlProgramsControlProgramIdMutationResult = NonNullable<
    Awaited<ReturnType<typeof patchControlProgramsControlProgramId>>
>;
export type PatchControlProgramsControlProgramIdMutationBody =
    UpdatableControlProgram;
export type PatchControlProgramsControlProgramIdMutationError =
    AxiosError<ControlEntityConflict>;

export const usePatchControlProgramsControlProgramId = <
    TError = AxiosError<ControlEntityConflict>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof patchControlProgramsControlProgramId>>,
            TError,
            {
                controlProgramId: ControlProgramId;
                data: UpdatableControlProgram;
            },
            TContext
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<typeof patchControlProgramsControlProgramId>>,
    TError,
    { controlProgramId: ControlProgramId; data: UpdatableControlProgram },
    TContext
> => {
    return useMutation(
        getPatchControlProgramsControlProgramIdMutationOptions(options),
        queryClient
    );
};
export const getControlProgramsControlProgramIdReport = (
    controlProgramId: ControlProgramId,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<null>> => {
    return axios.get(
        `/api/control-programs/${controlProgramId}/report`,
        options
    );
};

export const getGetControlProgramsControlProgramIdReportQueryKey = (
    controlProgramId: ControlProgramId
) => {
    return [`/api/control-programs/${controlProgramId}/report`] as const;
};

export const getGetControlProgramsControlProgramIdReportQueryOptions = <
    TData = Awaited<
        ReturnType<typeof getControlProgramsControlProgramIdReport>
    >,
    TError = AxiosError<null>,
>(
    controlProgramId: ControlProgramId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<typeof getControlProgramsControlProgramIdReport>
                >,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getGetControlProgramsControlProgramIdReportQueryKey(controlProgramId);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getControlProgramsControlProgramIdReport>>
    > = ({ signal }) =>
        getControlProgramsControlProgramIdReport(controlProgramId, {
            signal,
            ...axiosOptions,
        });

    return {
        queryKey,
        queryFn,
        enabled: controlProgramId !== null && controlProgramId !== undefined,
        ...queryOptions,
    } as UseQueryOptions<
        Awaited<ReturnType<typeof getControlProgramsControlProgramIdReport>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetControlProgramsControlProgramIdReportQueryResult = NonNullable<
    Awaited<ReturnType<typeof getControlProgramsControlProgramIdReport>>
>;
export type GetControlProgramsControlProgramIdReportQueryError =
    AxiosError<null>;

export function useGetControlProgramsControlProgramIdReport<
    TData = Awaited<
        ReturnType<typeof getControlProgramsControlProgramIdReport>
    >,
    TError = AxiosError<null>,
>(
    controlProgramId: ControlProgramId,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<typeof getControlProgramsControlProgramIdReport>
                >,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            typeof getControlProgramsControlProgramIdReport
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            typeof getControlProgramsControlProgramIdReport
                        >
                    >
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetControlProgramsControlProgramIdReport<
    TData = Awaited<
        ReturnType<typeof getControlProgramsControlProgramIdReport>
    >,
    TError = AxiosError<null>,
>(
    controlProgramId: ControlProgramId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<typeof getControlProgramsControlProgramIdReport>
                >,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            typeof getControlProgramsControlProgramIdReport
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            typeof getControlProgramsControlProgramIdReport
                        >
                    >
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetControlProgramsControlProgramIdReport<
    TData = Awaited<
        ReturnType<typeof getControlProgramsControlProgramIdReport>
    >,
    TError = AxiosError<null>,
>(
    controlProgramId: ControlProgramId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<typeof getControlProgramsControlProgramIdReport>
                >,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetControlProgramsControlProgramIdReport<
    TData = Awaited<
        ReturnType<typeof getControlProgramsControlProgramIdReport>
    >,
    TError = AxiosError<null>,
>(
    controlProgramId: ControlProgramId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<typeof getControlProgramsControlProgramIdReport>
                >,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions =
        getGetControlProgramsControlProgramIdReportQueryOptions(
            controlProgramId,
            options
        );

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getGetControlProgramsControlProgramIdReportSuspenseQueryOptions = <
    TData = Awaited<
        ReturnType<typeof getControlProgramsControlProgramIdReport>
    >,
    TError = AxiosError<null>,
>(
    controlProgramId: ControlProgramId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<
                    ReturnType<typeof getControlProgramsControlProgramIdReport>
                >,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getGetControlProgramsControlProgramIdReportQueryKey(controlProgramId);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getControlProgramsControlProgramIdReport>>
    > = ({ signal }) =>
        getControlProgramsControlProgramIdReport(controlProgramId, {
            signal,
            ...axiosOptions,
        });

    return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getControlProgramsControlProgramIdReport>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetControlProgramsControlProgramIdReportSuspenseQueryResult =
    NonNullable<
        Awaited<ReturnType<typeof getControlProgramsControlProgramIdReport>>
    >;
export type GetControlProgramsControlProgramIdReportSuspenseQueryError =
    AxiosError<null>;

export function useGetControlProgramsControlProgramIdReportSuspense<
    TData = Awaited<
        ReturnType<typeof getControlProgramsControlProgramIdReport>
    >,
    TError = AxiosError<null>,
>(
    controlProgramId: ControlProgramId,
    options: {
        query: Partial<
            UseSuspenseQueryOptions<
                Awaited<
                    ReturnType<typeof getControlProgramsControlProgramIdReport>
                >,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetControlProgramsControlProgramIdReportSuspense<
    TData = Awaited<
        ReturnType<typeof getControlProgramsControlProgramIdReport>
    >,
    TError = AxiosError<null>,
>(
    controlProgramId: ControlProgramId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<
                    ReturnType<typeof getControlProgramsControlProgramIdReport>
                >,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetControlProgramsControlProgramIdReportSuspense<
    TData = Awaited<
        ReturnType<typeof getControlProgramsControlProgramIdReport>
    >,
    TError = AxiosError<null>,
>(
    controlProgramId: ControlProgramId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<
                    ReturnType<typeof getControlProgramsControlProgramIdReport>
                >,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetControlProgramsControlProgramIdReportSuspense<
    TData = Awaited<
        ReturnType<typeof getControlProgramsControlProgramIdReport>
    >,
    TError = AxiosError<null>,
>(
    controlProgramId: ControlProgramId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<
                    ReturnType<typeof getControlProgramsControlProgramIdReport>
                >,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions =
        getGetControlProgramsControlProgramIdReportSuspenseQueryOptions(
            controlProgramId,
            options
        );

    const query = useSuspenseQuery(
        queryOptions,
        queryClient
    ) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getControlProgramsControlProgramIdDatasheetAssignments = (
    controlProgramId: ControlProgramId,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<DataSheetAssignmentsListDto>> => {
    return axios.get(
        `/api/control-programs/${controlProgramId}/datasheet-assignments`,
        options
    );
};

export const getGetControlProgramsControlProgramIdDatasheetAssignmentsQueryKey =
    (controlProgramId: ControlProgramId) => {
        return [
            `/api/control-programs/${controlProgramId}/datasheet-assignments`,
        ] as const;
    };

export const getGetControlProgramsControlProgramIdDatasheetAssignmentsQueryOptions =
    <
        TData = Awaited<
            ReturnType<
                typeof getControlProgramsControlProgramIdDatasheetAssignments
            >
        >,
        TError = AxiosError<unknown>,
    >(
        controlProgramId: ControlProgramId,
        options?: {
            query?: Partial<
                UseQueryOptions<
                    Awaited<
                        ReturnType<
                            typeof getControlProgramsControlProgramIdDatasheetAssignments
                        >
                    >,
                    TError,
                    TData
                >
            >;
            axios?: AxiosRequestConfig;
        }
    ) => {
        const { query: queryOptions, axios: axiosOptions } = options ?? {};

        const queryKey =
            queryOptions?.queryKey ??
            getGetControlProgramsControlProgramIdDatasheetAssignmentsQueryKey(
                controlProgramId
            );

        const queryFn: QueryFunction<
            Awaited<
                ReturnType<
                    typeof getControlProgramsControlProgramIdDatasheetAssignments
                >
            >
        > = ({ signal }) =>
            getControlProgramsControlProgramIdDatasheetAssignments(
                controlProgramId,
                { signal, ...axiosOptions }
            );

        return {
            queryKey,
            queryFn,
            enabled:
                controlProgramId !== null && controlProgramId !== undefined,
            ...queryOptions,
        } as UseQueryOptions<
            Awaited<
                ReturnType<
                    typeof getControlProgramsControlProgramIdDatasheetAssignments
                >
            >,
            TError,
            TData
        > & { queryKey: DataTag<QueryKey, TData, TError> };
    };

export type GetControlProgramsControlProgramIdDatasheetAssignmentsQueryResult =
    NonNullable<
        Awaited<
            ReturnType<
                typeof getControlProgramsControlProgramIdDatasheetAssignments
            >
        >
    >;
export type GetControlProgramsControlProgramIdDatasheetAssignmentsQueryError =
    AxiosError<unknown>;

export function useGetControlProgramsControlProgramIdDatasheetAssignments<
    TData = Awaited<
        ReturnType<
            typeof getControlProgramsControlProgramIdDatasheetAssignments
        >
    >,
    TError = AxiosError<unknown>,
>(
    controlProgramId: ControlProgramId,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getControlProgramsControlProgramIdDatasheetAssignments
                    >
                >,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            typeof getControlProgramsControlProgramIdDatasheetAssignments
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            typeof getControlProgramsControlProgramIdDatasheetAssignments
                        >
                    >
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetControlProgramsControlProgramIdDatasheetAssignments<
    TData = Awaited<
        ReturnType<
            typeof getControlProgramsControlProgramIdDatasheetAssignments
        >
    >,
    TError = AxiosError<unknown>,
>(
    controlProgramId: ControlProgramId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getControlProgramsControlProgramIdDatasheetAssignments
                    >
                >,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            typeof getControlProgramsControlProgramIdDatasheetAssignments
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            typeof getControlProgramsControlProgramIdDatasheetAssignments
                        >
                    >
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetControlProgramsControlProgramIdDatasheetAssignments<
    TData = Awaited<
        ReturnType<
            typeof getControlProgramsControlProgramIdDatasheetAssignments
        >
    >,
    TError = AxiosError<unknown>,
>(
    controlProgramId: ControlProgramId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getControlProgramsControlProgramIdDatasheetAssignments
                    >
                >,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetControlProgramsControlProgramIdDatasheetAssignments<
    TData = Awaited<
        ReturnType<
            typeof getControlProgramsControlProgramIdDatasheetAssignments
        >
    >,
    TError = AxiosError<unknown>,
>(
    controlProgramId: ControlProgramId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getControlProgramsControlProgramIdDatasheetAssignments
                    >
                >,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions =
        getGetControlProgramsControlProgramIdDatasheetAssignmentsQueryOptions(
            controlProgramId,
            options
        );

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getGetControlProgramsControlProgramIdDatasheetAssignmentsSuspenseQueryOptions =
    <
        TData = Awaited<
            ReturnType<
                typeof getControlProgramsControlProgramIdDatasheetAssignments
            >
        >,
        TError = AxiosError<unknown>,
    >(
        controlProgramId: ControlProgramId,
        options?: {
            query?: Partial<
                UseSuspenseQueryOptions<
                    Awaited<
                        ReturnType<
                            typeof getControlProgramsControlProgramIdDatasheetAssignments
                        >
                    >,
                    TError,
                    TData
                >
            >;
            axios?: AxiosRequestConfig;
        }
    ) => {
        const { query: queryOptions, axios: axiosOptions } = options ?? {};

        const queryKey =
            queryOptions?.queryKey ??
            getGetControlProgramsControlProgramIdDatasheetAssignmentsQueryKey(
                controlProgramId
            );

        const queryFn: QueryFunction<
            Awaited<
                ReturnType<
                    typeof getControlProgramsControlProgramIdDatasheetAssignments
                >
            >
        > = ({ signal }) =>
            getControlProgramsControlProgramIdDatasheetAssignments(
                controlProgramId,
                { signal, ...axiosOptions }
            );

        return {
            queryKey,
            queryFn,
            ...queryOptions,
        } as UseSuspenseQueryOptions<
            Awaited<
                ReturnType<
                    typeof getControlProgramsControlProgramIdDatasheetAssignments
                >
            >,
            TError,
            TData
        > & { queryKey: DataTag<QueryKey, TData, TError> };
    };

export type GetControlProgramsControlProgramIdDatasheetAssignmentsSuspenseQueryResult =
    NonNullable<
        Awaited<
            ReturnType<
                typeof getControlProgramsControlProgramIdDatasheetAssignments
            >
        >
    >;
export type GetControlProgramsControlProgramIdDatasheetAssignmentsSuspenseQueryError =
    AxiosError<unknown>;

export function useGetControlProgramsControlProgramIdDatasheetAssignmentsSuspense<
    TData = Awaited<
        ReturnType<
            typeof getControlProgramsControlProgramIdDatasheetAssignments
        >
    >,
    TError = AxiosError<unknown>,
>(
    controlProgramId: ControlProgramId,
    options: {
        query: Partial<
            UseSuspenseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getControlProgramsControlProgramIdDatasheetAssignments
                    >
                >,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetControlProgramsControlProgramIdDatasheetAssignmentsSuspense<
    TData = Awaited<
        ReturnType<
            typeof getControlProgramsControlProgramIdDatasheetAssignments
        >
    >,
    TError = AxiosError<unknown>,
>(
    controlProgramId: ControlProgramId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getControlProgramsControlProgramIdDatasheetAssignments
                    >
                >,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetControlProgramsControlProgramIdDatasheetAssignmentsSuspense<
    TData = Awaited<
        ReturnType<
            typeof getControlProgramsControlProgramIdDatasheetAssignments
        >
    >,
    TError = AxiosError<unknown>,
>(
    controlProgramId: ControlProgramId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getControlProgramsControlProgramIdDatasheetAssignments
                    >
                >,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetControlProgramsControlProgramIdDatasheetAssignmentsSuspense<
    TData = Awaited<
        ReturnType<
            typeof getControlProgramsControlProgramIdDatasheetAssignments
        >
    >,
    TError = AxiosError<unknown>,
>(
    controlProgramId: ControlProgramId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getControlProgramsControlProgramIdDatasheetAssignments
                    >
                >,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions =
        getGetControlProgramsControlProgramIdDatasheetAssignmentsSuspenseQueryOptions(
            controlProgramId,
            options
        );

    const query = useSuspenseQuery(
        queryOptions,
        queryClient
    ) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getControlPrograms = (
    params?: GetControlProgramsParams,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<ControlProgramOverviewResourceListDto>> => {
    return axios.get(`/api/control-programs`, {
        paramsSerializer: { indexes: null },
        ...options,
        params: { ...params, ...options?.params },
    });
};

export const getGetControlProgramsQueryKey = (
    params?: GetControlProgramsParams
) => {
    return [`/api/control-programs`, ...(params ? [params] : [])] as const;
};

export const getGetControlProgramsQueryOptions = <
    TData = Awaited<ReturnType<typeof getControlPrograms>>,
    TError = AxiosError<unknown>,
>(
    params?: GetControlProgramsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getControlPrograms>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getGetControlProgramsQueryKey(params);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getControlPrograms>>
    > = ({ signal }) => getControlPrograms(params, { signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getControlPrograms>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetControlProgramsQueryResult = NonNullable<
    Awaited<ReturnType<typeof getControlPrograms>>
>;
export type GetControlProgramsQueryError = AxiosError<unknown>;

export function useGetControlPrograms<
    TData = Awaited<ReturnType<typeof getControlPrograms>>,
    TError = AxiosError<unknown>,
>(
    params: undefined | GetControlProgramsParams,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getControlPrograms>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getControlPrograms>>,
                    TError,
                    Awaited<ReturnType<typeof getControlPrograms>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetControlPrograms<
    TData = Awaited<ReturnType<typeof getControlPrograms>>,
    TError = AxiosError<unknown>,
>(
    params?: GetControlProgramsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getControlPrograms>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getControlPrograms>>,
                    TError,
                    Awaited<ReturnType<typeof getControlPrograms>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetControlPrograms<
    TData = Awaited<ReturnType<typeof getControlPrograms>>,
    TError = AxiosError<unknown>,
>(
    params?: GetControlProgramsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getControlPrograms>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetControlPrograms<
    TData = Awaited<ReturnType<typeof getControlPrograms>>,
    TError = AxiosError<unknown>,
>(
    params?: GetControlProgramsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getControlPrograms>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetControlProgramsQueryOptions(params, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getGetControlProgramsSuspenseQueryOptions = <
    TData = Awaited<ReturnType<typeof getControlPrograms>>,
    TError = AxiosError<unknown>,
>(
    params?: GetControlProgramsParams,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getControlPrograms>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getGetControlProgramsQueryKey(params);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getControlPrograms>>
    > = ({ signal }) => getControlPrograms(params, { signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getControlPrograms>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetControlProgramsSuspenseQueryResult = NonNullable<
    Awaited<ReturnType<typeof getControlPrograms>>
>;
export type GetControlProgramsSuspenseQueryError = AxiosError<unknown>;

export function useGetControlProgramsSuspense<
    TData = Awaited<ReturnType<typeof getControlPrograms>>,
    TError = AxiosError<unknown>,
>(
    params: undefined | GetControlProgramsParams,
    options: {
        query: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getControlPrograms>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetControlProgramsSuspense<
    TData = Awaited<ReturnType<typeof getControlPrograms>>,
    TError = AxiosError<unknown>,
>(
    params?: GetControlProgramsParams,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getControlPrograms>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetControlProgramsSuspense<
    TData = Awaited<ReturnType<typeof getControlPrograms>>,
    TError = AxiosError<unknown>,
>(
    params?: GetControlProgramsParams,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getControlPrograms>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetControlProgramsSuspense<
    TData = Awaited<ReturnType<typeof getControlPrograms>>,
    TError = AxiosError<unknown>,
>(
    params?: GetControlProgramsParams,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getControlPrograms>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetControlProgramsSuspenseQueryOptions(
        params,
        options
    );

    const query = useSuspenseQuery(
        queryOptions,
        queryClient
    ) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const postControlPrograms = (
    newControlProgram: NewControlProgram,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<ControlProgramOverviewResourceDto>> => {
    return axios.post(`/api/control-programs`, newControlProgram, options);
};

export const getPostControlProgramsMutationOptions = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postControlPrograms>>,
        TError,
        { data: NewControlProgram },
        TContext
    >;
    axios?: AxiosRequestConfig;
}): UseMutationOptions<
    Awaited<ReturnType<typeof postControlPrograms>>,
    TError,
    { data: NewControlProgram },
    TContext
> => {
    const mutationKey = ["postControlPrograms"];
    const { mutation: mutationOptions, axios: axiosOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postControlPrograms>>,
        { data: NewControlProgram }
    > = (props) => {
        const { data } = props ?? {};

        return postControlPrograms(data, axiosOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type PostControlProgramsMutationResult = NonNullable<
    Awaited<ReturnType<typeof postControlPrograms>>
>;
export type PostControlProgramsMutationBody = NewControlProgram;
export type PostControlProgramsMutationError = AxiosError<unknown>;

export const usePostControlPrograms = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postControlPrograms>>,
            TError,
            { data: NewControlProgram },
            TContext
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<typeof postControlPrograms>>,
    TError,
    { data: NewControlProgram },
    TContext
> => {
    return useMutation(
        getPostControlProgramsMutationOptions(options),
        queryClient
    );
};
export const patchControlPrograms = (
    updatableControlPrograms: UpdatableControlPrograms,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<void>> => {
    return axios.patch(
        `/api/control-programs`,
        updatableControlPrograms,
        options
    );
};

export const getPatchControlProgramsMutationOptions = <
    TError = AxiosError<ControlEntityConflict>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof patchControlPrograms>>,
        TError,
        { data: UpdatableControlPrograms },
        TContext
    >;
    axios?: AxiosRequestConfig;
}): UseMutationOptions<
    Awaited<ReturnType<typeof patchControlPrograms>>,
    TError,
    { data: UpdatableControlPrograms },
    TContext
> => {
    const mutationKey = ["patchControlPrograms"];
    const { mutation: mutationOptions, axios: axiosOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof patchControlPrograms>>,
        { data: UpdatableControlPrograms }
    > = (props) => {
        const { data } = props ?? {};

        return patchControlPrograms(data, axiosOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type PatchControlProgramsMutationResult = NonNullable<
    Awaited<ReturnType<typeof patchControlPrograms>>
>;
export type PatchControlProgramsMutationBody = UpdatableControlPrograms;
export type PatchControlProgramsMutationError =
    AxiosError<ControlEntityConflict>;

export const usePatchControlPrograms = <
    TError = AxiosError<ControlEntityConflict>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof patchControlPrograms>>,
            TError,
            { data: UpdatableControlPrograms },
            TContext
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<typeof patchControlPrograms>>,
    TError,
    { data: UpdatableControlPrograms },
    TContext
> => {
    return useMutation(
        getPatchControlProgramsMutationOptions(options),
        queryClient
    );
};
export const postControlProgramsTagCategories = (
    newControlProgramTagCategoryWithTags: NewControlProgramTagCategoryWithTags,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<ControlProgramTagCategoryWithTagsView>> => {
    return axios.post(
        `/api/control-programs/tag-categories`,
        newControlProgramTagCategoryWithTags,
        options
    );
};

export const getPostControlProgramsTagCategoriesMutationOptions = <
    TError = AxiosError<null>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postControlProgramsTagCategories>>,
        TError,
        { data: NewControlProgramTagCategoryWithTags },
        TContext
    >;
    axios?: AxiosRequestConfig;
}): UseMutationOptions<
    Awaited<ReturnType<typeof postControlProgramsTagCategories>>,
    TError,
    { data: NewControlProgramTagCategoryWithTags },
    TContext
> => {
    const mutationKey = ["postControlProgramsTagCategories"];
    const { mutation: mutationOptions, axios: axiosOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postControlProgramsTagCategories>>,
        { data: NewControlProgramTagCategoryWithTags }
    > = (props) => {
        const { data } = props ?? {};

        return postControlProgramsTagCategories(data, axiosOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type PostControlProgramsTagCategoriesMutationResult = NonNullable<
    Awaited<ReturnType<typeof postControlProgramsTagCategories>>
>;
export type PostControlProgramsTagCategoriesMutationBody =
    NewControlProgramTagCategoryWithTags;
export type PostControlProgramsTagCategoriesMutationError = AxiosError<null>;

export const usePostControlProgramsTagCategories = <
    TError = AxiosError<null>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postControlProgramsTagCategories>>,
            TError,
            { data: NewControlProgramTagCategoryWithTags },
            TContext
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<typeof postControlProgramsTagCategories>>,
    TError,
    { data: NewControlProgramTagCategoryWithTags },
    TContext
> => {
    return useMutation(
        getPostControlProgramsTagCategoriesMutationOptions(options),
        queryClient
    );
};
export const deleteControlProgramsTagCategoriesTagCategoryId = (
    tagCategoryId: ControlProgramTagCategoryId,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<void>> => {
    return axios.delete(
        `/api/control-programs/tag-categories/${tagCategoryId}`,
        options
    );
};

export const getDeleteControlProgramsTagCategoriesTagCategoryIdMutationOptions =
    <TError = AxiosError<null>, TContext = unknown>(options?: {
        mutation?: UseMutationOptions<
            Awaited<
                ReturnType<
                    typeof deleteControlProgramsTagCategoriesTagCategoryId
                >
            >,
            TError,
            { tagCategoryId: ControlProgramTagCategoryId },
            TContext
        >;
        axios?: AxiosRequestConfig;
    }): UseMutationOptions<
        Awaited<
            ReturnType<typeof deleteControlProgramsTagCategoriesTagCategoryId>
        >,
        TError,
        { tagCategoryId: ControlProgramTagCategoryId },
        TContext
    > => {
        const mutationKey = ["deleteControlProgramsTagCategoriesTagCategoryId"];
        const { mutation: mutationOptions, axios: axiosOptions } = options
            ? options.mutation &&
              "mutationKey" in options.mutation &&
              options.mutation.mutationKey
                ? options
                : { ...options, mutation: { ...options.mutation, mutationKey } }
            : { mutation: { mutationKey }, axios: undefined };

        const mutationFn: MutationFunction<
            Awaited<
                ReturnType<
                    typeof deleteControlProgramsTagCategoriesTagCategoryId
                >
            >,
            { tagCategoryId: ControlProgramTagCategoryId }
        > = (props) => {
            const { tagCategoryId } = props ?? {};

            return deleteControlProgramsTagCategoriesTagCategoryId(
                tagCategoryId,
                axiosOptions
            );
        };

        return { mutationFn, ...mutationOptions };
    };

export type DeleteControlProgramsTagCategoriesTagCategoryIdMutationResult =
    NonNullable<
        Awaited<
            ReturnType<typeof deleteControlProgramsTagCategoriesTagCategoryId>
        >
    >;

export type DeleteControlProgramsTagCategoriesTagCategoryIdMutationError =
    AxiosError<null>;

export const useDeleteControlProgramsTagCategoriesTagCategoryId = <
    TError = AxiosError<null>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<
                ReturnType<
                    typeof deleteControlProgramsTagCategoriesTagCategoryId
                >
            >,
            TError,
            { tagCategoryId: ControlProgramTagCategoryId },
            TContext
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<typeof deleteControlProgramsTagCategoriesTagCategoryId>>,
    TError,
    { tagCategoryId: ControlProgramTagCategoryId },
    TContext
> => {
    return useMutation(
        getDeleteControlProgramsTagCategoriesTagCategoryIdMutationOptions(
            options
        ),
        queryClient
    );
};
export const getControlProgramsTags = (
    options?: AxiosRequestConfig
): Promise<AxiosResponse<ControlProgramTagViewListDto>> => {
    return axios.get(`/api/control-programs/tags`, options);
};

export const getGetControlProgramsTagsQueryKey = () => {
    return [`/api/control-programs/tags`] as const;
};

export const getGetControlProgramsTagsQueryOptions = <
    TData = Awaited<ReturnType<typeof getControlProgramsTags>>,
    TError = AxiosError<unknown>,
>(options?: {
    query?: Partial<
        UseQueryOptions<
            Awaited<ReturnType<typeof getControlProgramsTags>>,
            TError,
            TData
        >
    >;
    axios?: AxiosRequestConfig;
}) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getGetControlProgramsTagsQueryKey();

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getControlProgramsTags>>
    > = ({ signal }) => getControlProgramsTags({ signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getControlProgramsTags>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetControlProgramsTagsQueryResult = NonNullable<
    Awaited<ReturnType<typeof getControlProgramsTags>>
>;
export type GetControlProgramsTagsQueryError = AxiosError<unknown>;

export function useGetControlProgramsTags<
    TData = Awaited<ReturnType<typeof getControlProgramsTags>>,
    TError = AxiosError<unknown>,
>(
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getControlProgramsTags>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getControlProgramsTags>>,
                    TError,
                    Awaited<ReturnType<typeof getControlProgramsTags>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetControlProgramsTags<
    TData = Awaited<ReturnType<typeof getControlProgramsTags>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getControlProgramsTags>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getControlProgramsTags>>,
                    TError,
                    Awaited<ReturnType<typeof getControlProgramsTags>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetControlProgramsTags<
    TData = Awaited<ReturnType<typeof getControlProgramsTags>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getControlProgramsTags>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetControlProgramsTags<
    TData = Awaited<ReturnType<typeof getControlProgramsTags>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getControlProgramsTags>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetControlProgramsTagsQueryOptions(options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getGetControlProgramsTagsSuspenseQueryOptions = <
    TData = Awaited<ReturnType<typeof getControlProgramsTags>>,
    TError = AxiosError<unknown>,
>(options?: {
    query?: Partial<
        UseSuspenseQueryOptions<
            Awaited<ReturnType<typeof getControlProgramsTags>>,
            TError,
            TData
        >
    >;
    axios?: AxiosRequestConfig;
}) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getGetControlProgramsTagsQueryKey();

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getControlProgramsTags>>
    > = ({ signal }) => getControlProgramsTags({ signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getControlProgramsTags>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetControlProgramsTagsSuspenseQueryResult = NonNullable<
    Awaited<ReturnType<typeof getControlProgramsTags>>
>;
export type GetControlProgramsTagsSuspenseQueryError = AxiosError<unknown>;

export function useGetControlProgramsTagsSuspense<
    TData = Awaited<ReturnType<typeof getControlProgramsTags>>,
    TError = AxiosError<unknown>,
>(
    options: {
        query: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getControlProgramsTags>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetControlProgramsTagsSuspense<
    TData = Awaited<ReturnType<typeof getControlProgramsTags>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getControlProgramsTags>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetControlProgramsTagsSuspense<
    TData = Awaited<ReturnType<typeof getControlProgramsTags>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getControlProgramsTags>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetControlProgramsTagsSuspense<
    TData = Awaited<ReturnType<typeof getControlProgramsTags>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getControlProgramsTags>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetControlProgramsTagsSuspenseQueryOptions(options);

    const query = useSuspenseQuery(
        queryOptions,
        queryClient
    ) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const postControlProgramsTags = (
    newControlProgramTag: NewControlProgramTag,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<ControlProgramTagView>> => {
    return axios.post(
        `/api/control-programs/tags`,
        newControlProgramTag,
        options
    );
};

export const getPostControlProgramsTagsMutationOptions = <
    TError = AxiosError<null>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postControlProgramsTags>>,
        TError,
        { data: NewControlProgramTag },
        TContext
    >;
    axios?: AxiosRequestConfig;
}): UseMutationOptions<
    Awaited<ReturnType<typeof postControlProgramsTags>>,
    TError,
    { data: NewControlProgramTag },
    TContext
> => {
    const mutationKey = ["postControlProgramsTags"];
    const { mutation: mutationOptions, axios: axiosOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postControlProgramsTags>>,
        { data: NewControlProgramTag }
    > = (props) => {
        const { data } = props ?? {};

        return postControlProgramsTags(data, axiosOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type PostControlProgramsTagsMutationResult = NonNullable<
    Awaited<ReturnType<typeof postControlProgramsTags>>
>;
export type PostControlProgramsTagsMutationBody = NewControlProgramTag;
export type PostControlProgramsTagsMutationError = AxiosError<null>;

export const usePostControlProgramsTags = <
    TError = AxiosError<null>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postControlProgramsTags>>,
            TError,
            { data: NewControlProgramTag },
            TContext
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<typeof postControlProgramsTags>>,
    TError,
    { data: NewControlProgramTag },
    TContext
> => {
    return useMutation(
        getPostControlProgramsTagsMutationOptions(options),
        queryClient
    );
};
export const deleteControlProgramsTagsTagId = (
    tagId: ControlProgramTagId,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<void>> => {
    return axios.delete(`/api/control-programs/tags/${tagId}`, options);
};

export const getDeleteControlProgramsTagsTagIdMutationOptions = <
    TError = AxiosError<null>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof deleteControlProgramsTagsTagId>>,
        TError,
        { tagId: ControlProgramTagId },
        TContext
    >;
    axios?: AxiosRequestConfig;
}): UseMutationOptions<
    Awaited<ReturnType<typeof deleteControlProgramsTagsTagId>>,
    TError,
    { tagId: ControlProgramTagId },
    TContext
> => {
    const mutationKey = ["deleteControlProgramsTagsTagId"];
    const { mutation: mutationOptions, axios: axiosOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof deleteControlProgramsTagsTagId>>,
        { tagId: ControlProgramTagId }
    > = (props) => {
        const { tagId } = props ?? {};

        return deleteControlProgramsTagsTagId(tagId, axiosOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type DeleteControlProgramsTagsTagIdMutationResult = NonNullable<
    Awaited<ReturnType<typeof deleteControlProgramsTagsTagId>>
>;

export type DeleteControlProgramsTagsTagIdMutationError = AxiosError<null>;

export const useDeleteControlProgramsTagsTagId = <
    TError = AxiosError<null>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof deleteControlProgramsTagsTagId>>,
            TError,
            { tagId: ControlProgramTagId },
            TContext
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<typeof deleteControlProgramsTagsTagId>>,
    TError,
    { tagId: ControlProgramTagId },
    TContext
> => {
    return useMutation(
        getDeleteControlProgramsTagsTagIdMutationOptions(options),
        queryClient
    );
};
export const postControlProgramsCopy = (
    params: PostControlProgramsCopyParams,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<ControlProgramOverview>> => {
    return axios.post(`/api/control-programs/copy`, undefined, {
        paramsSerializer: { indexes: null },
        ...options,
        params: { ...params, ...options?.params },
    });
};

export const getPostControlProgramsCopyMutationOptions = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postControlProgramsCopy>>,
        TError,
        { params: PostControlProgramsCopyParams },
        TContext
    >;
    axios?: AxiosRequestConfig;
}): UseMutationOptions<
    Awaited<ReturnType<typeof postControlProgramsCopy>>,
    TError,
    { params: PostControlProgramsCopyParams },
    TContext
> => {
    const mutationKey = ["postControlProgramsCopy"];
    const { mutation: mutationOptions, axios: axiosOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postControlProgramsCopy>>,
        { params: PostControlProgramsCopyParams }
    > = (props) => {
        const { params } = props ?? {};

        return postControlProgramsCopy(params, axiosOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type PostControlProgramsCopyMutationResult = NonNullable<
    Awaited<ReturnType<typeof postControlProgramsCopy>>
>;

export type PostControlProgramsCopyMutationError = AxiosError<unknown>;

export const usePostControlProgramsCopy = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postControlProgramsCopy>>,
            TError,
            { params: PostControlProgramsCopyParams },
            TContext
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<typeof postControlProgramsCopy>>,
    TError,
    { params: PostControlProgramsCopyParams },
    TContext
> => {
    return useMutation(
        getPostControlProgramsCopyMutationOptions(options),
        queryClient
    );
};
